export const FETCH_LAST_ACTIVE_CLIENTS = 'FETCH_LAST_ACTIVE_CLIENTS';
export const FETCH_ACTIVE_CLIENT_COUNT = 'FETCH_ACTIVE_CLIENT_COUNT';
export const FETCH_LAST_ACTIVE_DEVICES = 'FETCH_LAST_ACTIVE_DEVICES';
export const FETCH_ACTIVE_DEVICE_COUNT = 'FETCH_ACTIVE_DEVICE_COUNT';
